import React, { FC } from 'react'
import styled from 'styled-components'

import InfinityObserver from 'components/Observer/InfinityObserver'
import { ISection } from '../../interfaces'
import PotentialMailUsersIcon from './PotentialMailUsers'
import { SubTitle, Text, Title } from '../CssStyled'
import DisplayUsersIcon from './DisplayUsers'
import { breakpoints } from '@ads/front-core/constants/breakpoints'
import CurveIcon from './Curve'
import DisplayUsersMobileIcon from './DisplayUsersMobile'
import PotentialMailUserMobileIcon from './PotentialMailUserMobile'
import { Trans, lng } from '@ads/front-core/locales'

const OurPotential: FC<ISection> = ({ setActiveMenu }) => (
  <InfinityObserver callback={() => setActiveMenu('our-potential')}>
    <Container>
      <CurveIconWrapper>
        <CurveIcon />
      </CurveIconWrapper>

      <Wrapper>
        <TitleWrapper>
          <Title>
            <Trans
              i18nKey="landing:ourPotential"
              components={{
                bold: <Title bold />,
              }}
            />
          </Title>
        </TitleWrapper>

        <Content>
          <div>
            <SubTitleWrapper>
              <SubTitle>
                <Trans
                  i18nKey="landing:campaignDisplayPotential"
                  components={{
                    bold: <SubTitle bold />,
                  }}
                />
              </SubTitle>
            </SubTitleWrapper>
            <Text>
              <List>
                <Trans
                  i18nKey="landing:campaignDisplayPotentialElements"
                  components={{
                    listElement: <li />,
                    bold: <Text bold />,
                  }}
                />
              </List>
            </Text>
          </div>
          <IconMobile>
            <DisplayUsersMobileIcon />
          </IconMobile>
          <IconDesktop>
            <DisplayUsersIcon />
            <TextIconDisplayUsers bold>
              {lng('landing:displayUsers')}
            </TextIconDisplayUsers>
          </IconDesktop>
        </Content>
        <Content>
          <IconMobile>
            <PotentialMailUserMobileIcon />
          </IconMobile>
          <IconDesktop>
            <PotentialMailUsersIcon />
            <TextIconEmailUsers bold>
              {lng('landing:emailUsers')}
            </TextIconEmailUsers>
          </IconDesktop>
          <div>
            <SubTitleWrapper>
              <SubTitle>
                <Trans
                  i18nKey="landing:mailPotential"
                  components={{
                    bold: <SubTitle bold />,
                  }}
                />
              </SubTitle>
            </SubTitleWrapper>
            <Text>
              <List>
                <Trans
                  i18nKey="landing:mailPotentialElements"
                  components={{
                    listElement: <li />,
                    bold: <Text bold />,
                  }}
                />
              </List>
            </Text>
          </div>
        </Content>
      </Wrapper>
    </Container>
  </InfinityObserver>
)

const Container = styled.div`
  position: relative;
  margin-bottom: 40px;

  @media (max-width: ${breakpoints.MOBILE}) {
    margin-bottom: 67px;
  }
`

const Content = styled.div`
  display: flex;
  gap: 164px;

  &:nth-child(2) {
    margin-bottom: 166px;
  }

  &:last-of-type {
    margin-left: 160px;
  }

  @media (max-width: ${breakpoints.MOBILE}) {
    gap: 16px;

    &:nth-child(2) {
      flex-direction: column-reverse;
      margin-bottom: 90px;
    }

    &:last-of-type {
      flex-direction: column;
      margin-left: 0;
    }
  }
`

const Wrapper = styled.div`
  padding-top: 66px;
  padding-left: 60px;

  @media (max-width: ${breakpoints.MOBILE}) {
    padding-left: 0;
  }
`

const TitleWrapper = styled.div`
  margin-bottom: 64px;

  @media (max-width: ${breakpoints.MOBILE}) {
    margin-bottom: 50px;
  }
`

const List = styled.ul`
  margin: 0 0 24px;

  @media (max-width: ${breakpoints.MOBILE}) {
    margin: 0;
  }
`

const CurveIconWrapper = styled.div`
  svg {
    width: 100%;
    position: absolute;
    z-index: -1;

    @media (max-width: 1440px) {
      display: none;
    }
  }

  &::before {
    content: '';
    position: absolute;
    left: 50%;
    right: 50%;
    width: 100vw;
    margin-left: -50vw;
    margin-right: -50vw;
    height: 120px;
    top: 0;
    background: linear-gradient(
      180deg,
      #f2f3f5 4.98%,
      rgba(255, 255, 255, 0) 85.4%
    );
    top: 9px;
    z-index: -1;
  }
`

const SubTitleWrapper = styled.div`
  margin-bottom: 24px;
`

const IconDesktop = styled.span`
  display: block;
  position: relative;

  @media (max-width: ${breakpoints.MOBILE}) {
    display: none;
  }
`

const TextIconDisplayUsers = styled(Text)`
  display: block;
  position: absolute;
  bottom: 40px;
  left: 142px;
`

const TextIconEmailUsers = styled(Text)`
  display: block;
  position: absolute;
  bottom: 64px;
  left: 113px;
`

const IconMobile = styled.span`
  display: none;

  @media (max-width: ${breakpoints.MOBILE}) {
    display: block;
    text-align: center;
  }
`

export default OurPotential
